import { formatCostCode } from "./costCode";

type ProductDropdownItem = {
  productName?: string | null;
  availableQuantity?: number | string | null;
  qty?: number | string | null;
  displayQuantity?: string | null;
  rackName?: string | null;
  rackLabel?: string | null;
  shelfLabel?: string | null;
  latestPurchasePrice?: number | string | null;
};

const emptyValue = "";

export const formatProductDropdownLabel = (product: ProductDropdownItem) => {
  const quantity =
    product.displayQuantity ||
    product.availableQuantity ||
    product.qty ||
    emptyValue;

  const costCode = product.latestPurchasePrice
    ? formatCostCode(product.latestPurchasePrice)
    : emptyValue;

  return [
    product.productName || emptyValue,
    costCode ? `(${costCode})` : emptyValue,
    `(${quantity})`,
    `${product.rackLabel || emptyValue}`,
    `${product.shelfLabel || emptyValue}`,
  ].filter(Boolean).join(" ");
};

export const findProductById = <T extends { id?: number | string }>(
  products: T[] | undefined,
  productId: number | string | null | undefined,
) => products?.find((product) => Number(product.id) === Number(productId));
